<template>
  <div>
    <div v-if="title">
      <h3 class="storefront-title no-select">{{ title }}</h3>
    </div>
    <div v-else>
      <div class="text-ui-placeholder hide-on-mobile"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StorefrontTitle",
  props: {
    title: {
      type: String,
      required: false
    }
  }
};
</script>

<style scoped></style>
